import {
  CloudServerOutlined,
  DatabaseOutlined,
  GlobalOutlined,
  TeamOutlined,
} from '@ant-design/icons'
import type { components } from '@fluencelabs/vodopad-admin-api'
import { Card, Col, Row, Statistic } from 'antd'

import {
  type CardState,
  ResourceStatistic,
} from '@/components/common/ResourceStatistic'
import { formatCount } from '@/utils/count'

import type { IpStats } from '../hooks/useResourceStats'

type AdminDashboardDto = components['schemas']['AdminDashboardDto']

const IP_FAMILY_LABELS = [
  ['V4', 'IPv4'],
  ['V6', 'IPv6'],
] as const

export function StatCards({
  stats,
  activeVms,
  statsLoading,
  storage,
  ips,
}: {
  stats?: AdminDashboardDto
  activeVms?: number
  statsLoading: boolean
  storage: CardState<number>
  ips: CardState<IpStats>
}) {
  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} lg={5}>
        <Card>
          <Statistic
            title="Total Users"
            value={stats?.usersTotal ?? '—'}
            suffix={stats ? `/ ${stats.usersActive} active` : undefined}
            prefix={<TeamOutlined />}
            loading={statsLoading}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} lg={5}>
        <Card>
          <Statistic
            title="Active VMs"
            value={activeVms ?? '—'}
            prefix={<CloudServerOutlined />}
            loading={statsLoading}
          />
        </Card>
      </Col>
      {/* No free-storage figure: no capacity source yet (graph @cloudless/fluence, #2185) */}
      <Col xs={24} sm={12} lg={5}>
        <Card>
          <ResourceStatistic
            title="Ready disks (GB)"
            state={storage}
            errorText="Failed to load storage"
            value={(gb) => gb.toLocaleString()}
            prefix={<DatabaseOutlined />}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} lg={9}>
        <Card>
          <Row gutter={16}>
            {IP_FAMILY_LABELS.map(([family, label]) => (
              <Col span={12} key={family}>
                <ResourceStatistic
                  title={`${label} in use / free`}
                  state={ips}
                  errorText="Failed to load public IPs"
                  value={(stats) => formatCount(stats[family].used)}
                  suffix={(stats) => `/ ${formatCount(stats[family].free)}`}
                  prefix={<GlobalOutlined />}
                />
              </Col>
            ))}
          </Row>
        </Card>
      </Col>
    </Row>
  )
}
